import { render } from "./LanguageSelector.vue?vue&type=template&id=7b74e3de&scoped=true&ts=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=7b74e3de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b74e3de"]])

export default __exports__